import { render, staticRenderFns } from "./DSError.vue?vue&type=template&id=7b83e5dc&scoped=true&"
import script from "./DSError.vue?vue&type=script&lang=js&"
export * from "./DSError.vue?vue&type=script&lang=js&"
import style0 from "./DSError.vue?vue&type=style&index=0&id=7b83e5dc&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b83e5dc",
  null
  
)

export default component.exports